<template>
  <div class="wapper">
    <el-page-header @back="goBack" content="核销信息详情" class="header">
    </el-page-header>
    <div class="content-wapper" v-if="null != info">
      <span class="title">核销信息</span>
      <ul class="info-wapper">
        <li>
          <div>
            <label>核销编号</label>
            <span>{{ info.verifyCode }}</span>
          </div>
          <div>
            <label>核销金额</label>
            <span>{{ info.verifyAmount }}</span>
          </div>
          <div>
            <label>核销时间</label>
            <span>{{ info.verifyTime }}</span>
          </div>
        </li>
        <li>
          <div>
            <el-tooltip placement="top-start">
              <div slot="content">1、在核款时限之前核销，且回款时间为本月前，归属账期为上月；<br/>2、在核款时限之后核销，或回款时间为本月，归属账期为本月；</div>
              <label class="icon-question">归属账期</label>
            </el-tooltip>
            <span>{{ info.collectionPeriod }}</span>
          </div>
          <div>
            <label>核销类型</label>
            <span>{{ info.verifyTypeName }}</span>
          </div>
          <div>
            <label>销售姓名</label>
            <span>{{ info.ownerUserName }}</span>
          </div>
        </li>
        <li>
          <div>
            <label>关联订单编号</label>
            <span>{{ info.orderNo }}</span>
          </div>
          <div>
            <label>订单类型</label>
            <span>{{ info.orderTypeName }}</span>
          </div>
          <div>
            <label>操作人</label>
            <span>{{ info.operatorName }}</span>
          </div>
        </li>
      </ul>
      <div class="images-wapper">
        <span class="title">关联流水</span>
        <ul class="info-wapper">
          <li>
            <div>
              <label>银行流水</label>
              <span>{{ info.tradeNo }}</span>
            </div>
            <div>
              <label>流水序列号</label>
              <span>{{ info.flowCode }}</span>
            </div>
            <div>
              <label>客户账户名称</label>
              <span>{{ info.accountName }}</span>
            </div>
          </li>
          <li>
            <div>
              <label>合约公司账户名称</label>
              <span>{{ info.contractAccountName }}</span>
            </div>
            <div>
              <label>收付时间</label>
              <span>{{ info.payTime }}</span>
            </div>
          </li>
        </ul>
      </div>

      <div class="images-wapper">
        <span class="title">编辑记录</span>

        <el-table :data="infoTableData" size="mini" :border="true">
          <el-table-column prop="verifyCode" label="核销编号"></el-table-column>
          <el-table-column
            prop="beforeEdit"
            label="编辑前内容"
          ></el-table-column>
          <el-table-column
            prop="afterEdit"
            label="编辑后内容"
          ></el-table-column>
          <el-table-column prop="gmtCreate" label="编辑时间"></el-table-column>
          <el-table-column prop="creatorName" label="操作人"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import _paymentService from "@/service/payment-inquiry-service";
export default {
  data() {
    return {
      id: this.$route.query.id,
      info: {},
      infoTableData: [],
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      _paymentService.orderVerifyDetail(
        { id: this.id },
        (response) => {
          // 请求成功
          this.info = response;
          this.getVerifyLogListFun(this.info.verifyCode);
        },
        (response) => {
          this.$notify({
            message: response,
            type: "warning",
          });
        }
      );
    },
    getVerifyLogListFun(verifyCode) {
      _paymentService.getVerifyLogList(
        { verifyCode: verifyCode },
        (response) => {
          // 请求成功
          this.infoTableData = response;
        },
        (response) => {
          this.$notify({
            message: response,
            type: "warning",
          });
        }
      );
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.wapper {
  padding: 15px;
}
.header {
  margin-bottom: 15px;
}
.content-wapper {
  border: 1px solid #d6dbe5;
  border-radius: 3px;
  padding: 30px;
  padding-top: 15px;
  background: #fff;
}
.title {
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  margin: 30px 0 10px 0;
}
.info-wapper li {
  margin: 15px 0;
}
.info-wapper div {
  display: inline-block;
  width: 300px;
  position: relative;
}
.info-wapper .special {
  width: 800px;
}
.info-wapper .orderType {
  width: 550px;
}
.info-wapper span {
  margin-left: 158px;
  display: inline-block;
  vertical-align: top;
}
.info-wapper label {
  color: #909399;
  display: inline-block;
  width: 145px;
  text-align: right;
  position: absolute;
  top: 0;
}
.textarea {
  display: inline-block;
  width: 500px;
}
.images-wapper {
  border-top: 1px dashed #909399;
  margin-top: 30px;
}
.info-wapper .el-image {
  width: 210px;
  height: 100px;
  border-radius: 6px;
  margin-left: 15px;
}
.table-wapper {
  margin-left: 130px;
  width: 550px;
}
.table-wapper label {
  padding: 10px 0;
  text-align: center;
  width: 100%;
  display: block;
  font-weight: bold;
  border: 1px solid #d6dbe5;
  border-bottom: none;
}
.table-wapper table {
  border: 1px solid #d6dbe5;
  width: 100%;
}
.table-wapper td {
  padding: 10px;
  border-bottom: 1px solid #d6dbe5;
  border-right: 1px solid #d6dbe5;
}
.table-wapper tr:first-child td {
  font-weight: bold;
  background: #f9f9f9;
}
.icon-question::before{
  font-family: element-icons !important;
  font-family: element-icons !important;
  content: "\e7a4";
  color: #383E43;
}
</style>
